import { type Masked, unmask } from '~/contentful/graphql';
import LineDiagonal from '~/ui/assets/icons/line-diagonal.svg';
import { Event, trackEvent } from '~/ui/components/analytics';
import { Link } from '~/ui/components/link';
import { Image } from '~/ui/modules/image';
import { getInternalLinkFromFragment } from '~/ui/systems/internalLink';
import { Route } from '~/ui/systems/internalLink/route';

import styles from './idea.module.scss';
import { type Idea_IdeaFragment } from './query';

type AvailableLinkProps = Omit<React.ComponentProps<typeof Link>, 'href'>;

export interface IdeaProps extends AvailableLinkProps {
  idea: Masked<typeof Idea_IdeaFragment>;
  showSeparator?: boolean;
}

export function Idea({ idea: parentIdea, showSeparator, onClick, ...linkProps }: IdeaProps) {
  const idea = unmask<typeof Idea_IdeaFragment>(parentIdea);

  return (
    <Link
      href={getInternalLinkFromFragment(idea)}
      className={styles.ideaLink}
      onClick={e => {
        trackEvent(Event.NAVIGATION_FOOTER, {
          navigationItem: idea.name ?? undefined,
          navigationLink: `${Route.IDEA}/${idea.slug}`,
        });
        onClick?.(e);
      }}
      {...linkProps}
    >
      <div className={styles.ideaImage}>
        {idea.navigationImagePortrait && (
          <Image
            image={idea.navigationImagePortrait}
            aspectRatio="2/3"
            width={48}
            height={64}
            fill={false}
          />
        )}
      </div>
      {idea.name}
      {showSeparator && <LineDiagonal aria-hidden />}
    </Link>
  );
}
